import React, { useState } from 'react';
import { Button, ButtonToolbar, Form, Loader, InputPicker } from "rsuite";
import Modal from "rsuite/Modal";
import { useFormik } from "formik";
import { rsuiteInputOnchangeFormikHandler, rsuiteInputPickerOnchangeFormikHandler } from "util/Helper";
import useRequestHandler from "hooks/useRequestHandler";
import { validationSchema } from './validationSchemas';

const EditBed = (props) => {

    const { auth, formValues, facilityId, modalOpen, setModalOpen, refreshData } = props;
    const { bedId, sectionName } = formValues;

    const [sectionData, setSectionData] = useState([]);

    const [loaderContent, setLoaderContent] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const getSectionsRequest = useRequestHandler({
        auth,
        apiArguments: [facilityId],
        apiName: 'getSectionsNames',
        successMessageData: { show: false },
        errorMessageData: {
            title: 'Warning',
            message: 'Unable to load sections, just add a new one.',
            type: 'info'
        }
    })
    const getSections = async () => {
        setLoaderContent('Loading sections');
        setIsLoading(true);
        await getSectionsRequest(data => {
            setSectionData(data.map(item => ({ label: item, value: item })))
        });
        setIsLoading(false);
    }

    const editBedRequest = useRequestHandler({
        auth,
        apiArguments: [facilityId, sectionName, bedId],
        apiName: 'updateBed',
        successMessageData: {
            message: 'Bed was successfully updated',
            duration: 3000
        },
        errorMessageData: {
            title: 'Error',
            message: 'Something went wrong while updating bed, check data and try again.',
            type: 'error'
        }
    })

    const formik = useFormik({
        initialValues: {...formValues, sectionName: { label: formValues.sectionName, value: formValues.sectionName }},
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values, { resetForm }) => {
            setLoaderContent('Updating bed');
            setIsLoading(true);

            values.sectionName = values.sectionName.value;

            await editBedRequest(
                async () => {
                    resetForm();
                    await refreshData();
                    setModalOpen(false);
                },
                null,
                [{ ...values }]
            )
         
            setIsLoading(false);
        }

    });

    const closeModal = (e) => {
        formik.resetForm();
        setModalOpen(false);
    }

    const formikOnInputChange = rsuiteInputOnchangeFormikHandler(formik.handleChange);
    const formikOnInputPickerChange = rsuiteInputPickerOnchangeFormikHandler(formik.handleChange, 'sectionName', sectionData, setSectionData);

    return (
        <Modal onOpen={getSections} open={modalOpen} onClose={closeModal} className="bed-modal edit-bed-modal">
            <Modal.Header>
                <Modal.Title><strong>Edit Bed</strong></Modal.Title>
            </Modal.Header>

            {isLoading &&
                <div className='loader-wrapper'>
                    <Loader size='lg' center content={loaderContent} />
                </div>}

            <Modal.Body className={isLoading ? 'hidden' : ''}>
                <Form fluid onSubmit={formik.handleSubmit}>
                    <Form.Group controlId="section">
                        <Form.ControlLabel className='edit-bed-label edit-bed-label-required'>Section</Form.ControlLabel>

                        <Form.Control
                            className={'edit-bed-input'}
                            accepter={InputPicker}
                            creatable
                            data={sectionData}
                            name="sectionName"
                            placeholder='Section name'
                            value={formik.values.sectionName.value}
                            onChange={formikOnInputPickerChange}
                            errorMessage={formik.touched.sectionName && formik.errors.sectionName ? "Section field is required and cannot includes special characters except dash and underscore" : null}
                        />
                    </Form.Group>

                    <Form.Group controlId="room">
                        <Form.ControlLabel className='edit-bed-label edit-bed-label-required'>Room</Form.ControlLabel>
                        <Form.Control
                            className={'edit-bed-input'}
                            type='text'
                            name='roomName'
                            placeholder='Room'
                            onChange={formikOnInputChange}
                            value={formik.values.roomName}
                            errorMessage={formik.touched.roomName && formik.errors.roomName ? formik.errors.roomName : null}
                        />
                    </Form.Group>

                    <Form.Group controlId="bed">
                        <Form.ControlLabel className='edit-bed-label'>Bed name</Form.ControlLabel>
                        <Form.Control
                            type='text'
                            name='bedName'
                            placeholder='Bed name (optional)'
                            value={formik.values.bedName}
                            onChange={formikOnInputChange}
                            className={'edit-bed-input'}
                            errorMessage={formik.touched.bedName && formik.errors.bedName ? formik.errors.bedName : null}
                        />
                    </Form.Group>

                    <Form.Group controlId="bth-toolbar">
                        <ButtonToolbar className='btn-toolbar'>
                            <Button
                                type='reset'
                                appearance="ghost"
                                size='lg'
                                className='edit-bed-btn btn-cancel'
                                onClick={closeModal}
                            >Cancel</Button>
                            <Button
                                type='submit'
                                appearance="primary"
                                size='lg'
                                className='edit-bed-btn btn-save'
                            >Save</Button>
                        </ButtonToolbar>
                    </Form.Group>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
EditBed.defaultProps = {
    formValues: {
        sectionName: '',
        roomName: '',
        bedName: '',
        bedId: '',
    }
}

export default EditBed;